import { render, staticRenderFns } from "./FlickrIcon.vue?vue&type=template&id=29382924&"
import script from "./FlickrIcon.vue?vue&type=script&lang=js&"
export * from "./FlickrIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports